import { handleActions } from 'redux-actions';
import { isNil, get } from 'lodash';

const defaultCategoryData = {
	'-100': {
		id: -1,
		date: '2018-07-20 00:00:00',
		title: '',
		content: '',
		intro: '',
		image: '',
		tags: [],
	},
};

const defaultNews = {
	id: -1,
	title: 'test',
	subtitle: 'test',
	content: '',
	date: '2018-07-20 00:00:00',
	bannerImage: '',
	tag: '住房優惠',
};

export default handleActions(
	{
		FETCH_HOTEL_NEWS_CATEGORY_FULFILLED: (state, action) => ({
			...state,
			categoryList: action.payload.categoryList,
			categoryData: action.payload.categoryData,
		}),

		FETCH_HOTEL_NEWS_LIST_FULFILLED: (state, action) => ({
			...state,
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage,
		}),

		FETCH_MORE_HOTEL_NEWS_LIST_FULFILLED: (state, action) => ({
			...state,
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage,
		}),

		FETCH_HOME_NEWS_LIST_FULFILLED: (state, action) => ({
			...state,
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage,
		}),
		
		FETCH_MORE_HOME_NEWS_LIST_FULFILLED: (state, action) => ({
			...state,
			newsList: action.payload.newsList,
			totalPage: action.payload.totalPage,
			currentPage: action.payload.currentPage,
		}),

		FETCH_HOTEL_NEWS_FULFILLED: (state, action) => ({
			...state,
			news: action.payload.news,
		}),

		FETCH_HOME_NEWS_FULFILLED: (state, action) => {
			if (isNil(get(action, 'payload', null))) {
				return {
					...state,
				};
			}

			return {
				...state,
				news: action.payload.news,
			};
		},
	},
	{
		categoryList: [],
		categoryData: defaultCategoryData,
		newsList: [],
		news: defaultNews,
		totalPage: 0,
		currentPage: 0,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/news.js